<script>
	import {API, http_headers} from '../global.js'
	export let voucher = 0

	let update = false
	let query = `select * from vistavoucher where idvoucher=${voucher}`

	$: refresh = async() => {
		const res = await fetch(`${API}/exec-query?u=${update}`,{ method:'POST', headers: http_headers, body:JSON.stringify({query}) })
		const data = await res.json()
		if(res.ok) return data.data[0]
		else {
			return []
			throw new Error(data)
		}
	}
</script>

<div class="modal fade show" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" role="dialog" aria-modal="true" style="display:block;background-color: rgba(150,150,150,0.5);">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Voucher #{voucher}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" on:click={()=>voucher=0}></button>
      </div>
      <div class="modal-body">
        {#await refresh()}
			<p>Loading....</p>
		{:then rs}
			{#each Object.keys(rs) as item, index}
				<div class="row my-2 border-bottom">
					<div class="col-3">{item}</div><div class="col-1">&nbsp;</div>
					<div class="col-8">{rs[item] || ''}</div>
				</div>
			{/each}
		{/await}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" on:click={()=>voucher=0}>Close</button>
        <button type="button" class="btn btn-primary" on:click={()=>update=!update}>Actualizar</button>
      </div>
    </div>
  </div>
</div>
